export default __webpack_public_path__ + "static/media/mobile_banner_onboarding.8163b689.png";